const getCornerRadiusClasses = (cornerRadiuses, size = 200)=>{
    if (!cornerRadiuses) {
        return {};
    }
    return Object.entries(cornerRadiuses).reduce((accumulator, [breakpoint, [topStart, topEnd, bottomStart, bottomEnd]])=>{
        const responsivePrefix = breakpoint === 'xs' ? '' : `-${breakpoint}`;
        accumulator[`rounded-top-start${responsivePrefix}-${topStart ? size : 0}`] = true;
        accumulator[`rounded-top-end${responsivePrefix}-${topEnd ? size : 0}`] = true;
        accumulator[`rounded-bottom-start${responsivePrefix}-${bottomStart ? size : 0}`] = true;
        accumulator[`rounded-bottom-end${responsivePrefix}-${bottomEnd ? size : 0}`] = true;
        return accumulator;
    }, {});
};

export { getCornerRadiusClasses };
